var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hover-youtube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.893,
    height: 12.581,
    viewBox: "0 0 17.893 12.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-youtube",
    "data-name": "Icon awesome-youtube",
    d: "M18.569,6.469a2.248,2.248,0,0,0-1.582-1.592A53.133,53.133,0,0,0,10,4.5a53.133,53.133,0,0,0-6.991.376A2.248,2.248,0,0,0,1.424,6.469,23.586,23.586,0,0,0,1.05,10.8a23.586,23.586,0,0,0,.374,4.335A2.215,2.215,0,0,0,3.006,16.7,53.133,53.133,0,0,0,10,17.081a53.133,53.133,0,0,0,6.991-.376,2.215,2.215,0,0,0,1.582-1.567,23.586,23.586,0,0,0,.374-4.335A23.586,23.586,0,0,0,18.569,6.469Zm-10.4,7V8.143L12.843,10.8l-4.677,2.66Z",
    transform: "translate(-1.05 -4.5)",
    fill: "#00649e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a3a24305ea8e8d21e3290ed6d71fa1df.svg";
export { ForwardRef as ReactComponent };